import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const SupportDialog = () => {
    const { userId: routeUserId } = useParams();
    const location = useLocation();

    const [userId, setUserId] = useState(routeUserId);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [fallbackName, setFallbackName] = useState(null);
    const [fallbackEmail, setFallbackEmail] = useState(null);
    const [intercomReady, setIntercomReady] = useState(false);

    useEffect(() => {
        if (routeUserId) {
            setUserId(routeUserId);
            setLoading(true);
            fetch('https://api.wiseclean.ee/api:t2VGHK4N/intercom/syncUser', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ userID: routeUserId })
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Ошибка syncUser');
                    }
                    return response.json();
                })
                .then(() => {
                    setUserId(routeUserId);
                })
                .catch(err => {
                    setError(err.message);
                })
                .finally(() => {
                    setLoading(false);
                    setIntercomReady(true);
                });
        } else {
            const params = new URLSearchParams(location.search);
            const email = params.get('email');
            const name = params.get('name');
            if (email && name) {
                setFallbackName(name);
                setFallbackEmail(email);
                setIntercomReady(true);
            }
        }
    }, [routeUserId, location.search]);

    useEffect(() => {
        if (!intercomReady || loading) {
            return;
        }

        if (!window.Intercom) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://widget.intercom.io/widget/jrhx7375';
            script.onload = () => {
                initializeIntercom();
            };
            document.head.appendChild(script);
        } else {
            initializeIntercom();
        }
    }, [userId, fallbackName, fallbackEmail, loading, error, intercomReady]);

    const initializeIntercom = () => {
        let intercomConfig = {
            app_id: 'jrhx7375',
            hide_default_launcher: true,
        };

        if (userId) {
            intercomConfig.user_id = userId;
        } else if (fallbackName && fallbackEmail) {
            intercomConfig.name = fallbackName;
            intercomConfig.email = fallbackEmail;
        }

        window.Intercom('boot', intercomConfig);
        window.Intercom('show');

        window.Intercom('onHide', () => {
            setTimeout(() => {
                window.Intercom('show');
            }, 50);
        });
    };

    useEffect(() => {
        return () => {
            window.Intercom('shutdown');
        };
    }, []);

    return null;
};

export default SupportDialog;
